import { colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const LinkStyled = styled.a`
  color: ${colors.blue[600]};
  font-weight: 700;
`;
